import '@/css/app.css'
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import Autosize from '@marcreichel/alpine-autosize'

import './cookie-consent-mode.js'
import './base/revealOnScroll.js'
import './base/parallax.js'

import './components/cursor-next-project.js'
import './components/cursor-next-article.js'
import './components/shadow-text.js'
import './components/footer-reveal.js'
import './components/highlight-text-on-scroll.js'

import './components/clipReveal.js'

import './components/cursor-text.js'

import './base/cables.js'

import { resumeCanvas1, pauseCanvas1 } from './base/cables.js'

import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

import Lenis from 'lenis'

const isTouch = window.innerWidth < 1024

// const lenis = new Lenis({
//     autoRaf: true,
//     anchors: {
//         offset: -50
//     }
// })
let lenis

let forceNormalizeScroll = false

const servicesCards = document.querySelector('.servicesCards')

if (servicesCards) {
    forceNormalizeScroll = true
}

if (servicesCards) {
    ScrollTrigger.normalizeScroll(true)
} else {
    lenis = new Lenis({
        lerp: 0.165,
        wheelMultiplier: 1.25,
        // autoRaf: true,
        anchors: {
            offset: -50
        },
        prevent: (node) => {
            const classes = ['pm-wrapper']
            return classes.some((cls) => node.classList.contains(cls))
        }
    })
    window.lenis = lenis

    lenis.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)
}

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function () {
        return !!(
            this.currentTime > 0 &&
            !this.paused &&
            !this.ended &&
            this.readyState > 2
        )
    }
})

function handleUserInteraction() {
    const videos = document.querySelectorAll('video')

    videos.forEach((video) => {
        if (video.playing) {
            // video is already playing → do nothing
        } else {
            video.play()
        }
    })
}

document.body.addEventListener('click', handleUserInteraction)
document.body.addEventListener('touchstart', handleUserInteraction)

const initHeadroomOnSticky = () => {
    const header =
        document.querySelector('header[data-headroom-enabled]') ||
        document.querySelector('header')
    const mainContent = document.querySelector('main')

    if (!header || !mainContent) {
        return
    }

    const showHeader = () => {
        gsap.to(header, {
            yPercent: 0,
            duration: 0.25,
            ease: 'none',
            overwrite: 'auto'
        })
    }

    const hideHeader = () => {
        gsap.to(header, {
            yPercent: -100,
            duration: 0.25,
            ease: 'none',
            overwrite: 'auto'
        })
    }

    const MAIN_END_HEADROOM_START_OFFSET_PX = Math.max(header.offsetHeight, 250)

    gsap.set(header, { yPercent: 0 })

    ScrollTrigger.create({
        id: 'headroom-main-end',
        trigger: mainContent,
        start: () => `bottom bottom-=${MAIN_END_HEADROOM_START_OFFSET_PX}`,
        end: 'bottom top',
        // markers: true,
        refreshPriority: -2000,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
            if (self.direction === 1) {
                hideHeader()
                return
            }

            showHeader()
        },
        onLeaveBack: showHeader
    })
}

const initArrowHideOnScroll = () => {
    const arrow = document.querySelector('.js-arrow')
    if (!arrow) return

    const showArrow = () => {
        gsap.to(arrow, {
            autoAlpha: 1,
            duration: 0.2,
            ease: 'power2.out',
            overwrite: 'auto'
        })
    }

    const hideArrow = () => {
        gsap.to(arrow, {
            autoAlpha: 0,
            duration: 0.2,
            ease: 'power2.out',
            overwrite: 'auto'
        })
    }

    gsap.set(arrow, { autoAlpha: 1 })

    ScrollTrigger.create({
        id: 'arrow-hide-on-scroll',
        // markers: true,
        start: () => window.innerHeight * 0.5,
        end: () => ScrollTrigger.maxScroll(window),
        invalidateOnRefresh: true,
        onEnter: hideArrow,
        onLeaveBack: showArrow
    })
}

// App main
const main = async () => {
    // Dit komt overeen met de twig var blockHandle
    // const blocks = []
    const components = [
        'fancybox',
        'swiper',
        'accordionComp',
        'langSwitcher',
        'googleMaps',
        'faq',
        'count',
        'plyr',
        'workPages',
        'servicesCards',
        'tabs'
    ]

    const importPromises = []

    // for (const block of blocks) {
    //     const blockElements = document.querySelectorAll(`.${block}`)

    //     if (blockElements.length === 0) {
    //         continue
    //     }

    //     const importPromise = import(`./blocks/${block}.js`).then(
    //         ({ init }) => {
    //             blockElements.forEach((block) => {
    //                 importPromises.push(init(block))
    //             })
    //         }
    //     )

    //     importPromises.push(importPromise)
    // }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)
        if (compElements.length === 0) {
            continue
        }

        const importPromise = import(`./components/${comp}.js`).then(
            ({ init }) => {
                compElements.forEach((comp) => {
                    importPromises.push(init(comp, lenis))
                })
            }
        )

        importPromises.push(importPromise)
    }

    importPromises.push(
        import('./base/animations.js').then(({ initAnimations }) =>
            initAnimations()
        )
    )

    importPromises.push(
        import('./base/menu.js').then(({ initMenu }) => initMenu())
    )
    // allSettled: één falende import mag Alpine en de rest niet blokkeren
    const results = await Promise.allSettled(importPromises)
    results
        .filter(({ status }) => status === 'rejected')
        .forEach(({ reason }) => console.error(reason))

    initHeadroomOnSticky()
    initArrowHideOnScroll()
    ScrollTrigger.refresh()
}

main().then(() => {
    console.log('Vite <3')
    window.Alpine = Alpine

    Alpine.plugin(collapse)
    Alpine.plugin(Autosize)
    Alpine.start()

    const anchor = getAnchor()
    if (anchor) {
        const anchorElement = document.querySelector(`#${anchor}`)
        if (anchorElement) {
            setTimeout(() => {
                lenis.scrollTo(anchorElement, {
                    offset: -50
                })
            }, 500)
        }
    }

    const input = document.querySelector('.ghost-input')
    const ghost = document.getElementById('ghost')

    function syncWidth() {
        if (ghost && input) {
            ghost.textContent = input.value || input.placeholder
            input.style.width = ghost.offsetWidth + 'px'
        }
    }

    // loadPatch()

    syncWidth()
    // input.addEventListener('input', syncWidth)

    footerMenu()

    const closePopupBtn = document.querySelector('.close-btn')
    if (closePopupBtn) {
        closePopupBtn.addEventListener('click', () => {
            const popup = document.querySelector('.js-popup')
            if (popup) {
                popup.remove()
            }
        })
    }
})

function showError(initiator, ...args) {
    CABLES.logErrorConsole('[' + initiator + ']', ...args)
}

function patchInitialized(patch, options) {
    console.log('patchInitialized')
    // You can now access the patch object (patch), register variable watchers and so on
}

function patchFinishedLoading(patch, options) {}

function createPatch({ canvasId, options }) {
    const patch = new CABLES.Patch({
        patch: CABLES.exportedPatch,
        prefixAssetPath: '',
        assetPath: 'assets/',
        jsPath: 'js/',
        glCanvasId: canvasId,
        glCanvasResizeToWindow: true,
        onError: showError,
        onPatchLoaded: patchInitialized,
        onFinishedLoading: patchFinishedLoading,
        canvas: {
            alpha: true,
            premultipliedAlpha: true
        },
        variables: {
            options: {
                darkTheme:
                    document.querySelector('.js-footerCanvas') == null
                        ? false
                        : true
            }
        }
    })

    return patch
}

// const loadPatch = () => {
//     const initPatch = () => {
//         const canvas = document.getElementById('glcanvas')
//         if (!canvas) {
//             return false
//         }

//         if (!window.CABLES || !CABLES.Patch || !CABLES.exportedPatch) {
//             return false
//         }

//         const patch1 = createPatch({
//             canvasId: 'glcanvas'
//             // options: {
//             //     darkTheme: false
//             // }
//         })

//         const canvasFooter = document.querySelector('.js-footerCanvas')

//         if (canvasFooter == null) {
//             let passed = false

//             const st = ScrollTrigger.create({
//                 trigger: 'js-home-canvas',
//                 // markers: true,
//                 start: 'top top',
//                 end: () => ScrollTrigger.maxScroll(window),

//                 onUpdate: (self) => {
//                     const over100vh = self.scroll() >= window.innerHeight

//                     if (over100vh && !passed) {
//                         passed = true
//                         console.log('OVER 100vh')
//                         // 👉 actie bij voorbij 100vh naar beneden

//                         patch1.pause()
//                     }

//                     if (!over100vh && passed) {
//                         passed = false
//                         console.log('TERUG ONDER 100vh')
//                         // 👉 actie bij terug omhoog

//                         patch1.resume()
//                     }
//                 }
//             })
//         } else {
//             const main = document.querySelector('main')
//             const header = document.querySelector('header')
//             patch1.pause()
//             if (main && header) {
//                 ScrollTrigger.create({
//                     id: 'patch1-footer-visibility',
//                     trigger: main,
//                     start: () => `bottom bottom`,
//                     end: () => ScrollTrigger.maxScroll(window),
//                     invalidateOnRefresh: true,
//                     // markers: true,
//                     refreshPriority: -2000,
//                     onEnter: () => {
//                         console.log(
//                             '[patch1] resume: footer in beeld / header hide'
//                         )
//                         patch1.resume()
//                     },
//                     onLeaveBack: () => {
//                         console.log(
//                             '[patch1] pause: footer uit beeld / header terug'
//                         )
//                         patch1.pause()
//                     }
//                 })
//             }
//         }

//         return true
//     }

//     if (!initPatch()) {
//         document.addEventListener('CABLES.jsLoaded', initPatch, { once: true })
//     }

//     // disable rubberband effect on mobile devices
//     const canvas = document.getElementById('glcanvas')
//     if (canvas) {
//         canvas.addEventListener(
//             'touchmove',
//             (e) => {
//                 e.preventDefault()
//             },
//             false
//         )
//     }
// }

const changeItemsOnHover = ({
    parentSelector,
    itemSelector,
    ignoreSelector,
    activeClass = 'hoverActive'
}) => {
    // Event delegation op document: SplitText (autoSplit in highlight-text-on-scroll)
    // vervangt de innerHTML van de titel opnieuw na het laden van fonts of bij resize,
    // waardoor listeners op de items zelf verloren gaan.
    const getHoverItem = (target) => {
        if (!(target instanceof Element)) return null

        const el = target.closest(itemSelector)
        if (!el || !el.closest(parentSelector)) return null

        // als dit element óók een ignore is => geen hover-effect
        if (ignoreSelector && el.matches(ignoreSelector)) return null

        return el
    }

    const setHoverActive = (el, active) => {
        const parent = el.closest(parentSelector)
        if (!parent) return

        parent.classList.toggle(activeClass, active)

        // alle andere items (behalve de hovered zelf)
        parent.querySelectorAll(itemSelector).forEach((item) => {
            item.classList.toggle(activeClass, active && item !== el)
        })

        // ignore items moeten ook hoverActive (ook al zitten ze al in de items)
        if (ignoreSelector) {
            parent.querySelectorAll(ignoreSelector).forEach((item) => {
                item.classList.toggle(activeClass, active)
            })
        }
    }

    document.addEventListener('mouseover', (e) => {
        const el = getHoverItem(e.target)
        // bewegen binnen hetzelfde item (bv. tussen SplitText words) negeren
        if (!el || el.contains(e.relatedTarget)) return

        setHoverActive(el, true)
    })

    document.addEventListener('mouseout', (e) => {
        const el = getHoverItem(e.target)
        if (!el || el.contains(e.relatedTarget)) return

        setHoverActive(el, false)
    })
}

const footerMenu = () => {
    const main = document.querySelector('main')
    const header = document.querySelector('header')

    if (!main || !header) {
        return
    }

    const getHeaderHeight = () => header.offsetHeight || 0

    if (getHeaderHeight() === 0) {
        return
    }

    gsap.timeline({
        scrollTrigger: {
            trigger: main,
            start: `bottom-=${getHeaderHeight() * 2} top`,
            invalidateOnRefresh: true,
            // markers: true,
            toggleActions: 'play reverse play reverse',
            onEnter: function () {
                header.classList.add('hide')
            },
            onLeaveBack: function () {
                header.classList.remove('hide')
            }
        }
    })
}

const syncWorkCardsActiveState = () => {
    const cardAnchors = document.querySelectorAll('[data-sync-active-state]')

    cardAnchors.forEach((c) => {
        const id = c.getAttribute('data-sync-active-state')
        const selector = `[data-sync-active-state="${id}"]`
        const matchingElements = document.querySelectorAll(selector)

        const feedItem = c.closest('[data-hover-feed]')
        const feedParent = c.closest('[data-hover-feed-parent]')

        let relatedFeedItems = []
        if (feedParent) {
            relatedFeedItems = feedParent.querySelectorAll('[data-hover-feed]')
        }

        c.addEventListener('mouseenter', () => {
            // bestaande active-state sync
            matchingElements.forEach((el) => {
                el.classList.add('active')
            })

            // nieuwe hover-feed logica
            if (feedParent) {
                feedParent.classList.add('hoverActive')

                relatedFeedItems.forEach((item) => {
                    if (item !== feedItem) {
                        item.classList.add('hoverActive')
                    }
                })
            }
        })

        c.addEventListener('mouseleave', () => {
            // bestaande active-state sync
            matchingElements.forEach((el) => {
                el.classList.remove('active')
            })

            // nieuwe hover-feed logica
            if (feedParent) {
                feedParent.classList.remove('hoverActive')

                relatedFeedItems.forEach((item) => {
                    item.classList.remove('hoverActive')
                })
            }
        })
    })
}

// Hover-states meteen binden en niet in main().then: die wacht op alle
// dynamische imports (trager) en wordt overgeslagen als main() faalt.
const hoverGroups = [
    {
        parentSelector: '[data-hover-title-parent]',
        itemSelector: '[data-hover-title]',
        ignoreSelector: '[data-hover-title-ignore]',
        activeClass: 'hoverActive'
    },
    {
        parentSelector: '[data-hover-nav-parent]',
        itemSelector: '[data-hover-nav]',
        ignoreSelector: '[data-hover-nav-ignore]',
        activeClass: 'hoverActive'
    },
    {
        parentSelector: '[data-hover-footer-parent]',
        itemSelector: '[data-hover-footer]',
        ignoreSelector: '[data-hover-footer-ignore]',
        activeClass: 'hoverActive'
    },
    {
        parentSelector: '[data-hover-contact-parent]',
        itemSelector: '[data-hover-contact]',
        ignoreSelector: '[data-hover-contact-ignore]',
        activeClass: 'hoverActive'
    },
    {
        parentSelector: '[data-hover-tabs-parent]',
        itemSelector: '[data-hover-tabs]',
        ignoreSelector: '[data-hover-tabs-ignore]',
        activeClass: 'hoverActive'
    }
]

hoverGroups.forEach((group) => {
    changeItemsOnHover(group)
})

syncWorkCardsActiveState()

const getAnchor = () => {
    var currentUrl = document.URL,
        urlParts = currentUrl.split('#')

    return urlParts.length > 1 ? urlParts[1] : null
}

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}
